module.exports = __webpack_public_path__ + "static/media/RunningDoodle.7a880f09.png";